module.exports = __webpack_public_path__ + "static/media/mobile1.ce895dcf.png";